module.exports = "<i class=\"fa fa-clock-o system-status-new-request\" title={{value}}></i>";